<script lang="ts">
    import { Col, Input } from "sveltestrap";
    import { OutlineColorVariant } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte";
    import {outlineselect} from  "../../../../Data/Forms/Widgets/Widgets"
</script>
<Col md="6">
    <Card headerTitle={OutlineColorVariant} cardHeaderprops="pb-0">
      <div slot="contentbody">
        {#each outlineselect as selectItem}
            <div class="mb-2">
                <div class="col-form-label">{selectItem.title}</div>
                <Input class="form-select form-control-{selectItem.class}" type="select" name="select" id="exampleSelect" value={selectItem.value}>
                    {#each selectItem.options as opt}
                        <option>{opt.opt1}</option>
                    {/each}
                </Input>
            </div>
        {/each}
      </div>
    </Card>
</Col>